import type { PayRule, PayRuleType, StackingMode } from "./types.js";

export function getActiveRule(rules: PayRule[], type: PayRuleType): PayRule | undefined {
  return rules
    .filter((r) => r.active !== false && r.type === type)
    .sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0))[0];
}

export function ruleMultiplier(rule: PayRule | undefined, fallback = 1): number {
  if (rule?.multiplier == null) return fallback;
  return rule.multiplier;
}

export function ruleThreshold(rule: PayRule | undefined, fallback: number): number {
  if (rule?.thresholdHours == null) return fallback;
  return rule.thresholdHours;
}

export function resolveStackedMultiplier(
  mode: StackingMode,
  multipliers: { value: number; priority?: number }[],
): number {
  const values = multipliers.map((m) => m.value).filter((v) => Number.isFinite(v) && v > 0);
  if (values.length === 0) return 1;

  switch (mode) {
    case "STACK_MULTIPLIERS":
      return values.reduce((acc, value) => acc * value, 1);
    case "CUSTOM_PRIORITY": {
      const sorted = [...multipliers].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
      const top = sorted.find((m) => m.value > 0);
      return top?.value ?? 1;
    }
    case "HIGHEST_MULTIPLIER_WINS":
    default:
      return Math.max(1, ...values);
  }
}

export function roundMoney(value: number): number {
  return Math.round(value * 100) / 100;
}

export function roundHours(value: number): number {
  return Math.round(value * 100) / 100;
}
